import React from 'react'
import ReactDOM from 'react-dom'
import { Form, Icon, Input, Button, Row, Col, DatePicker} from 'antd'
import moment from 'moment'
import eventTypes from './eventTypes';

const { TextArea } = Input;

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;


export const ValidationFormStep2 = (props) => {

    if (props.currentStep !== 'Step 2')  {
      return null
    }

  let isEventTypeOther = props.validationExistsSAEType === 'other';

    return(
      <div className="form-group">


            <h4 style={{ display: 'inline-block !important' }}>Site ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.siteID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>User ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.userID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>Subject ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.subjectID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>SAE Occurred: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
              {props.isSAEOccurred === true ? <div>Yes</div> : props.isSAEOccurred === false ? <div>No</div> : <div>Not entered</div> }
            </span></h4>

            {props.isSAEOccurred === true && <div>
              <h4 style={{  display: 'inline-block !important' }}>SAE event type: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                {eventTypes[props.validationExistsSAEType]}
              </span></h4>

              <h4 style={{  display: 'inline-block !important' }}>SAE comments: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                {props.validationExistsSAEComments}
              </span></h4>
              <h4 style={{  display: 'inline-block !important' }}>SAE Date: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                {props.saeDateInSiteTimezone}
              </span></h4>
            </div>}

            <Form.Item>
              <label>
                <h5>
                  Has a SAE occurred?
                </h5>
                {props.getFieldDecorator('validationExistsSAEOccurred', {
                  initialValue: '',
                  onChange: props.handleChange,
                  rules: [{
                    required: true,
                    message: 'Has an SAE occurred?'
                  }],
                })(
                    <select id="validationExistsSAEOccurred" name="validationExistsSAEOccurred" size="large" className="ant-input ant-input-lg">
                      <option value="">Please select an option</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                )}
              </label>
            </Form.Item>

            {props.validationExistsSAEOccurred === 'true' ?
                    <div>
                        <h3 style={{  display: 'inline-block !important' }}>SAE Information</h3>

                        <p style={{  display: 'inline-block !important', textAlign: 'center'  }}>You have indicated that an SAE has occurred. Please fill out the information below and also ensure that you have filled out the appropriate SAE form!</p>

                        <Form.Item>
                            {props.getFieldDecorator('validationExistsSAEDate', {
                                initialValue: props.validationExistsSAEDateMoment.utc().local(),
                                onChange: props.handleSAEDatePickerChange,
                                rules: [{
                                    required: true,
                                    message: 'Please select the date of the SAE'
                                }],
                            })(
                                <DatePicker
                                    id="validationExistsSAEDate"
                                    name="validationExistsSAEDate"
                                    prefix={<Icon type="user" style={{color: '#FAFAFA'}}/>}
                                    placeholder="SAE Date"
                                    disabledDate={(currentDate) => currentDate.diff(moment.now()) > 86400}
                                    allowClear
                                    size="large"
                                    className="ant-input ant-input-lg"
                                />
                            )}
                        </Form.Item>


                      <Form.Item>
                        <label>
                          <h5>
                            Event type
                          </h5>
                          {props.getFieldDecorator('validationExistsSAEType', {
                            initialValue: props.validationExistsSAEType,
                            onChange: props.handleChange,
                            rules: [{
                              message: 'Event type'
                            }],
                          })(
                              <select id="validationExistsSAEType" name="validationExistsSAEType" size="large" className="ant-input ant-input-lg">
                                <option value="">Please select an option</option>
                                <option value="symptomatic_intracerebral">Symptomatic intracerebral hemorrhage</option>
                                <option value="peripheral_bleeding">Peripheral bleeding requiring blood transfusion</option>
                                <option value="angioedema">Angioedema</option>
                                <option value="other">Others (give diagnosis, if possible)</option>
                                <option value="none">None</option>
                              </select>
                          )}
                        </label>
                      </Form.Item>

                      {isEventTypeOther && (<label>
                        <h5>
                          If other, please indicate what event occurred:
                        </h5>
                        <Form.Item>
                          {props.getFieldDecorator('other_event_comments', {
                            onChange: props.handleChange,
                            initialValue: props.other_event_comments
                          })(
                            <Input.TextArea id="other_event_comments" name="other_event_comments" />
                          )}
                        </Form.Item>
                      </label>)}

                      <Form.Item>
                        {props.getFieldDecorator('validationExistsSAEComments', {
                          initialValue: props.validationExistsSAEComments,
                          onChange: props.handleChange,
                          rules: [{
                            required: true,
                            message: 'SAE Comments'
                          }]
                        })(
                          <label>
                            <h5>
                              SAE Comments
                            </h5>
                            <TextArea
                              id="validationExistsSAEComments"
                              name="validationExistsSAEComments"
                              prefix={<Icon type="skin" style={{color: '#FAFAFA'}}/>}
                              placeholder="SAE Comments"
                              allowClear
                              size="large"
                              autoSize={{ minRows: 3, maxRows: 8 }}
                            />
                          </label>
                        )}
                      </Form.Item>

                    </div>

                :

                    <div>
                        <hr />
                        <p> </p>
                        <h3 style={{  display: 'inline-block !important' }}>SAE Information</h3>
                        <p style={{  display: 'inline-block !important', textAlign: 'center'  }}>You have indicated that an SAE has not occurred. If an SAE does occur, please fill out the appropriate SAE form!</p>
                    </div>

            }

      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/SaeRecording/Step2.js